import Container from '@/container';
import cx from 'classnames';
import {Col, Grid, Row} from '@/grid';
import withBreakpoints from '@/hocs/withBreakpoints';
import {SectionPadding} from '@/section';
import {LetterLine} from '@/svg/index';
import {H2, P} from '@/typography';
import PictureWrapper from '@/ui/images-wrapper';
import {useState} from 'react';
import {Waypoint} from 'react-waypoint';

import partnerStyles from 'pages/partnership-program/partners.module.scss';

const imgPath = '/static/images/partnership-program/channel-partners/';

const TrianglesImage = withBreakpoints({
  mobile: () => (
    <PictureWrapper
      imgPath={imgPath}
      imageUrl="triangles-mobile"
      imageTypeFallback="jpg"
      alt="Interest to impact"
    />
  )
});

const InterestToImpact = () => {
  const [active, setActive] = useState(false);

  return (
    <Waypoint
      topOffset="20%"
      bottomOffset="100%"
      onEnter={() => setActive(true)}
      fireOnRapidScroll={false}>
      <div>
        <SectionPadding>
          <Container>
            <Grid fluid>
              <div className={cx(partnerStyles['article-section-wrapper'])}>
                <TrianglesImage />

                <Row>
                  <Col sm={12} lg={12}>
                    <H2>From interest to impact</H2>

                    <P>
                      Community is more than connection. It’s momentum. Founders need more than
                      advice. They need access.{' '}
                      <span className={partnerStyles['text-highlight-yellow']}>
                        Partners like you help turn great ideas into great teams.
                      </span>
                    </P>
                    <P>
                      By sharing the tools that power smarter hiring, you help early-stage companies
                      grow with confidence while strengthening the networks that support them.
                    </P>
                    <P>
                      <span className={partnerStyles['text-highlight-yellow']}>
                        It starts with a simple step and builds into long-term impact.
                      </span>
                    </P>
                  </Col>
                </Row>
                <div className={partnerStyles['article-image']}>
                  <div className={cx(partnerStyles.line, partnerStyles.brown700)}>
                    <LetterLine active={active} />
                  </div>
                  <PictureWrapper
                    imgPath={imgPath}
                    imageUrl="triangles"
                    imageTypeFallback="jpg"
                    alt="Interest to impact"
                  />
                </div>
              </div>
            </Grid>
          </Container>
        </SectionPadding>
      </div>
    </Waypoint>
  );
};

export default InterestToImpact;
